// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"95":"18ec8ed7","746":"18ec8ed7"}[chunkId] + ".chunk.css";
};